export const meetingLocations = [
  { label: "Nashik", value: "Nashik", apiValue: "Nashik" },
  { label: "Online", value: "Online", apiValue: "Online" },
  { label: "Mumbai", value: "Mumbai", apiValue: "Mumbai" },
  { label: "Kutch", value: "Kutch", apiValue: "Kachchh" },
];

export const getMeetingLocationApiValue = (location) => {
  const match = meetingLocations.find((item) => item.value === location);
  return match?.apiValue;
};

export const meetingAbsenceLocations = [
  { label: "Nashik", value: "Nashik" },
  { label: "Others", value: "Others" },
];

export const getMeetingAbsenceLocationApiValue = (location) => {
  if (location === "Nashik") return "Nashik";
  return null;
};
